<div class="container">
    <i class="icon element-folder"></i>
    <div class="input-container">
        <form [formGroup]="inputGroup">
            <input
                type="text"
                class="form-control"
                [placeholder]="'main-new-folder' | translate"
                name="folder"
                autofocus
                formControlName="input"
            />
        </form>
    </div>
    <div class="action-container">
        <button
            type="button"
            class="btn btn-circle btn-sm btn-ghost element-ok"
            [attr.aria-label]="'a11y-confirm' | translate"
            [disabled]="inputGroup.invalid"
            (click)="createFolder()"
        ></button>
        <button
            type="button"
            class="btn btn-circle btn-sm btn-ghost element-cancel"
            [attr.aria-label]="'a11y-cancel' | translate"
            (click)="cancel()"
        ></button>
    </div>
</div>
